export default __webpack_public_path__ + "static/media/ubuntu.27cdf77d.svg";